<script setup lang="ts">
import { useToast } from '@ficpod/composables'

const { toasts, remove } = useToast()
</script>

<template>
  <div class="toast-container">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      class="toast"
      :class="`toast--${toast.type}`"
      @click="remove(toast.id)"
    >
      <span class="toast__message">{{ toast.message }}</span>
      <button class="toast__close" @click.stop="remove(toast.id)">&times;</button>
    </div>
  </div>
</template>

<style scoped>
.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 400px;
}

.toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  animation: slideIn 0.2s ease-out;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.toast--error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
}

.toast--success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  color: #16a34a;
}

.toast--info {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #2563eb;
}

.toast__message {
  flex: 1;
}

.toast__close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  opacity: 0.6;
  padding: 0;
  line-height: 1;
}

.toast__close:hover {
  opacity: 1;
}
</style>
